import { useMemo } from 'react'
import { scaleOrdinal } from 'd3-scale'
import { CHART_COLORS } from './types'

/**
 * Returns a d3 ordinal color scale using design system chart tokens.
 * Colors are CSS variables that auto-switch with dark mode.
 */
export function useChartColors(domain?: string[]) {
  return useMemo(() => {
    const scale = scaleOrdinal<string>()
      .range([...CHART_COLORS])

    if (domain) {
      scale.domain(domain)
    }

    return scale
  }, [domain])
}

/**
 * Resolve a CSS variable to its computed value.
 * Useful when D3 needs actual color values (e.g., for gradients).
 */
export function resolveColor(cssVar: string, fallback = '#6366f1'): string {
  if (typeof window === 'undefined') return fallback
  if (!cssVar.startsWith('var(')) return cssVar

  const varName = cssVar.replace(/^var\(/, '').replace(/\)$/, '')
  const computed = getComputedStyle(document.documentElement).getPropertyValue(varName).trim()
  return computed || fallback
}
